import { Fragment, useState, useRef, useEffect } from "react";
import {
  Autocomplete,
  Switch,
  Grid2 as Grid,
  FormControlLabel,
  TextField,
  CircularProgress,
} from "@mui/material";
import { Notifications } from "@mui/icons-material";
import BTDialogBox from "../../../components/BTDialgBox";
import BTButton from "../../../components/BTButton";
import BTInput from "../../../components/BTInput";
import secureLocalStorage from "react-secure-storage";
import authService from "../../../services/auth-service";
import { useNotification } from "../../../context";
import { isEqual } from "lodash";
import { useDispatch } from "react-redux";
import { get, insert, update, remove } from "../../../store/labSlice";
const AddSize = ({ open, setOpen }) => {
  const { addNotification } = useNotification();
  const dispatch = useDispatch();
  const { value, actionType } = open;
  const { u_id, admin_u_id, u_type } = secureLocalStorage.getItem("userdata");
  const initialState = {
    size_from: "0.00",
    size_to: "0.00",
    admin_u_id: u_type === 1 ? u_id : admin_u_id,
    size_desc: "",
    size_created_by: u_id,
    size_updated_by: u_id,
  };
  const [formData, setFormData] = useState(
    actionType === 1 ? [initialState] : value
  );
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const scrollRef = useRef(null);
  const validateForm = (records) => {
    const errors = {};
    if (!records || records.length === 0) {
      return errors;
    }
    records.forEach((record, index) => {
      const { size_from, size_to } = record;
      const recordsErrors = {};
      const addError = (field, message) => (recordsErrors[field] = message);

      if (size_from <= 0) {
        addError("size_from", "Size from must be greater than 0");
      }
      if (size_to <= 0) {
        addError("size_to", "Size to must be greater than 0");
      }
      if (Number(size_from) >= Number(size_to)) {
        addError("size_to", "Size to must be greater than size from");
        addError("size_from", "Size from must be less than size to");
      }

      if (Object.keys(recordsErrors).length > 0) {
        errors[index] = recordsErrors;
      }
    });
    for (let i = 1; i < records.length; i++) {
      const prevRecord = records[i - 1];
      const currentRecord = records[i];
      if (!errors[i - 1] && !errors[i]) {
        if (Number(prevRecord.size_to) >= Number(currentRecord.size_from)) {
          errors[i - 1] = errors[i - 1] || {};
          errors[i] = errors[i] || {};

          errors[i - 1].size_to =
            "Size to must be less than next record's size from";
          errors[i].size_from =
            "Size from must be greater than previous record's size to";
        }
      }
    }
    return errors;
  };
  const handleClose = () => {
    setOpen(false);
    setFormData(initialState);
  };

  const submitSize = async (e) => {
    e.preventDefault();
    const newErrors = validateForm(formData);
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      if (actionType === 2 && isEqual(formData, value)) {
        return addNotification({
          icon: <Notifications color="white" />,
          title: "Error!",
          message: "No changes to save",
          color: "error",
        });
      } else {
        try {
          setLoading(true);
          const isNewSize = actionType === 1;
          const response = isNewSize
            ? await authService.insert_size({ attributes: { data: formData } })
            : await authService.update_size({ attributes: { data: formData } });
          if (response?.status === 1) {
            isNewSize
              ? dispatch(
                  insert({
                    name: "sizes",
                    data: response?.data,
                    fetch: true,
                  })
                )
              : dispatch(
                  update({
                    name: "sizes",
                    key: "size_id",
                    data: response?.data,
                    fetch: true,
                  })
                );
            addNotification({
              icon: <Notifications color="white" />,
              title: "Success!",
              message: response?.message,
              color: "success",
            });
            handleClose();
          }
        } catch (error) {
          addNotification({
            icon: <Notifications color="white" />,
            title: "Error!",
            message: "Somthing Went Wrong!",
            color: "error",
          });
        } finally {
          setLoading(false);
        }
      }
    }
  };

  const handleChange = (index, e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === "checkbox" ? checked : value;
    setFormData((prev) => {
      const updatedRecords = [...prev];
      updatedRecords[index] = {
        ...updatedRecords[index],
        [name]: fieldValue,
      };
      return updatedRecords;
    });
    setErrors((prev) => {
      const newErrors = { ...prev };
      if (newErrors[index]?.[name]) {
        delete newErrors[index][name];
        if (Object.keys(newErrors[index]).length === 0) {
          delete newErrors[index];
        }
      }
      return newErrors;
    });
  };

  const handleAutocompleteChange = (name, value) => {
    let fieldValue = value?.value || "";
    setFormData((prev) => ({
      ...prev,
      [name]: fieldValue,
    }));
    const newErrors = validateForm({ ...formData, [name]: fieldValue });
    if (Object.keys(newErrors).length === 0) {
      setErrors((prevErrors) => {
        const { [name]: removedError, ...rest } = prevErrors;
        return rest;
      });
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: newErrors[name] || null,
      }));
    }
  };

  const handleSwitchChange = (name) => (e) => {
    setFormData((prev) => ({
      ...prev,
      [name]: e.target.checked ? 1 : 0,
    }));
  };

  const renderField = (field, index) => {
    const value = formData[index]?.[field.name];
    const error = errors[index]?.[field.name];
    switch (field.type) {
      case "select":
        return (
          <Autocomplete
            options={field?.options}
            value={field?.options.find((opt) => opt.value === value) || null}
            onChange={(_, value) =>
              handleAutocompleteChange(index, field.name, value)
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label={field.label}
                variant="standard"
                fullWidth
                error={!!error}
                helperText={error}
                required={field?.required || false}
              />
            )}
          />
        );

      case "checkbox":
      case "switch":
        return (
          <FormControlLabel
            control={
              <Switch
                checked={Boolean(formData[field.name]) || false}
                onChange={handleSwitchChange(field.name)}
                color="primary"
              />
            }
            label={field.label}
            labelPlacement="start"
            sx={{
              justifyContent: "space-between",
              marginLeft: 0,
              marginRight: 0,
              width: "100%",
            }}
          />
        );

      default:
        return (
          <BTInput
            name={field.name}
            step={field?.step || ""}
            label={field.label}
            type={field.type || "text"}
            value={value}
            onChange={(e) => handleChange(index, e)}
            inputProps={{ step: field?.step, min: field?.min }}
            variant="standard"
            required={field?.required || false}
            fullWidth
            error={!!error}
            helperText={error}
            {...field.props}
          />
        );
    }
  };

  const formFields = [
    {
      name: "size_from",
      label: "Size from",
      type: "number",
      step: "0.01",
      min: "0.00",
      gridSize: { xs: 12, md: 3 },
      required: true,
    },
    {
      name: "size_to",
      label: "Size to",
      type: "number",
      step: "0.01",
      min: "0.00",
      gridSize: { xs: 12, md: 3 },
      required: true,
    },
    {
      name: "size_desc",
      label: "Description",
      type: "text",
      gridSize: { xs: 12, md: 4 },
    },
  ];
  const addFields = () => {
    setFormData((prev) => [...prev, initialState]);
  };

  const removeFields = (size) => {
    if (size?.size_id) {
      const modiFiedData = formData?.map((item) => {
        if (item?.size_id === size?.size_id) {
          return { ...item, size_deleted: item?.size_deleted === 1 ? 0 : 1 };
        }
        return item;
      });
      setFormData(modiFiedData);
    } else {
      const filterData = formData?.filter((_, idx) => idx !== size);
      setFormData(filterData);
    }
  };
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [formData]);

  return (
    <BTDialogBox
      open={Boolean(open)}
      fullWidth
      maxWidth="lg"
      ref={scrollRef}
      onSubmit={submitSize}
      close={handleClose}
      title={actionType === 1 ? "Add size" : "Edit size"}
      buttons={[
        {
          name: "Cancel",
          color: "secondary",
          size: "small",
          onClick: handleClose,
        },
        {
          name: actionType === 1 ? "Submit" : "Edit",
          variant: "gradient",
          type: "submit",
          color: "dark",
          size: "small",
          loading: loading,
          loadingComponent: (
            <Fragment>
              <svg width={0} height={0}>
                <defs>
                  <linearGradient
                    id="my_gradient"
                    x1="0%"
                    y1="0%"
                    x2="0%"
                    y2="100%">
                    <stop offset="0%" stopColor="#e01cd5" />
                    <stop offset="100%" stopColor="#1CB5E0" />
                  </linearGradient>
                </defs>
              </svg>
              <CircularProgress
                size={22}
                sx={{
                  "svg circle": { stroke: "url(#my_gradient)" },
                }}
              />
            </Fragment>
          ),
          sx: { ml: 2, width: "80px" },
        },
      ]}>
      {formData?.map((item, index) => (
        <Grid container key={index} spacing={2}>
          <Fragment>
            {formFields?.map((field) => (
              <Grid
                size={{ ...field?.gridSize }}
                key={`${index}-${field.name}`}
                mt={1}>
                {renderField(field, index)}
              </Grid>
            ))}
            <Grid
              size={{ xs: 12, md: 2 }}
              mt={2.5}
              gap={1}
              display={"flex"}
              flexDirection={"row"}>
              {index === formData?.length - 1 && (
                <BTButton
                  color="dark"
                  variant={"gradient"}
                  disabled={formData?.length === 1}
                  size="small"
                  sx={{ width: { xs: "100%", md: "80px" }, height: "30px" }}
                  onClick={() => removeFields(item?.size_id ? item : index)}>
                  {!item?.size_deleted ? "Remove" : "Recover"}
                </BTButton>
              )}
              <BTButton
                color="dark"
                variant={"gradient"}
                size="small"
                sx={{ width: { xs: "100%", md: "60px", height: "30px" } }}
                onClick={() =>
                  index === formData?.length - 1
                    ? addFields()
                    : removeFields(item?.size_id ? item : index)
                }>
                {index === formData?.length - 1
                  ? "Add"
                  : !item?.size_deleted
                  ? "Remove"
                  : "Recover"}
              </BTButton>
            </Grid>
          </Fragment>
        </Grid>
      ))}
    </BTDialogBox>
  );
};

export default AddSize;
